import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMachine } from '@xstate/react';

import { useDefaultCurrency } from '/src/hooks';
import { editGoalMachine, STATES } from '/src/features/goals/machines/wizard';
import { GoalsWizard } from '/src/features/goals/components/wizard/GoalsWizard';

export function Component() {
  const params = useParams();
  const navigate = useNavigate();
  const abTestId = params?.id ?? null;

  const { defaultCurrency } = useDefaultCurrency();

  const [, , service] = useMachine(editGoalMachine, {
    devTools: true,
    context: {
      goalId: Number(params.goalId),
      previousPath: abTestId ? `/ab-tests/${abTestId}/goals` : `/goals/${params.goalId}`,
      defaultCurrency,
    },
  });

  useEffect(() => {
    const subscription = service.subscribe(async (state) => {
      if (state.matches(STATES.COMPLETED)) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }

      if (state.matches(STATES.CANCELLED)) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }
    });

    return subscription.unsubscribe;
  }, [navigate, service, params.goalId]);

  return <GoalsWizard goalId={Number(params.goalId)} service={service} />;
}
